import { questionFeature } from './question.reducer';

export const {
  selectQuestions,
  selectSearch,
  selectIsLoading,
  selectError,
  selectQuestionsState,
  selectSelectedId,
  selectDetail,
  selectIsDetailLoading,
  selectCompanies,
  selectCategories,
  selectParentQuestionSearchResults,
  selectChildQuestionSearchResults,
} = questionFeature;
